import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import { Select, Table, Button, Modal } from "antd";

import { fetchLimitsBonusesList } from "../../../redux/actions/premiumActions";

import ModalComponent from "../../../components/modalComponent/ModalComponent";
import { currentClientSelector } from "../../../redux/selectors/auth";

import ClientLimitForm from "./ClientLimit.form";
import UserLimitForm from "./UserLimit.form";
import { fetchUsers } from "../../../modules/presence/api/api";
const Help = () => {
  const [isVisible, setIsVisible] = useState(false);
  return (
    <React.Fragment>
      <Button type="primary" onClick={() => setIsVisible(true)}>
        Information
      </Button>
      <Modal
        title="Liste des primes"
        visible={isVisible}
        onOk={() => setIsVisible(false)}
        onCancel={() => setIsVisible(false)}
      >
        <p style={{ marginBottom: 16 }}> Ecran avec la liste des plafonds mensuels et trimestriels du dossier</p>

        <p style={{ marginTop: 4 }}>Actions possibles : </p>
        <p style={{ marginTop: 4, marginLeft: 10 }}>
          RH : modification des plafonds mensuels et trimestriels pour l'ensemble du dossier
        </p>
        <p style={{ marginTop: 4, marginLeft: 10 }}>
          RH : modification des plafonds mensuels et trimestriels pour un utilisateur
        </p>
      </Modal>
    </React.Fragment>
  );
};
const Limits = ({ limitsBonusesList = [], getLimitsBonusesList, client = {}, token }) => {
  const [isClientFormOpen, setIsClientFormOpen] = useState(false);
  const [isUserFormOpen, setIsUserFormOpen] = useState(false);
  const [userEmail, setUserEmail] = useState();
  const [users, setUsers] = useState([]);
  const initUsers = async () => {
    try {
      const response = await fetchUsers(
        {
          match: { "clients.id": client.id },
          sort: { email: 1 },
          project: { email: 1 }
        },
        token
      );
      if (Array.isArray(response)) {
        setUsers(response);
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    initUsers();
    getLimitsBonusesList();
  }, [client.id]);

  const columns = [
    {
      title: "Utilisateur",
      dataIndex: "user_email",
      key: "user_email",
      defaultSortOrder: "ascend",
      sorter: (a, b) => a.user_email.localeCompare(b.user_email)
    },

    {
      title: "Plafond mensuel",
      dataIndex: "monthly_limit",
      key: "limit",
      sorter: (a, b) => a.limit - b.limit
    },
    {
      title: "Plafond trimestriel",
      dataIndex: "quarterly_limit",
      key: "quarterly_limit",
      sorter: (a, b) => a.limit - b.limit
    },
    {
      title: "Plafond défini par",
      dataIndex: "limit_set_by.user_email",
      key: "limit_set_by.user_email"
    },

    {
      title: "Actions",
      dataIndex: "user_email",
      key: "user_id",
      render: user_email => (
        <a
          className="flex mt-2 cursor-pointer underline font-bold text-orange-400"
          onClick={() => {
            setUserEmail(user_email);
            setIsUserFormOpen(true);
          }}
        >
          Modifier
        </a>
      )
    }
  ];
  const selectedUser = users.find(user => user.email === userEmail) || {};
  const selectedUserId = selectedUser._id;
  const selectedLimitsBonus = limitsBonusesList.find(limit => limit.user_id === selectedUserId);

  return (
    <div className="w-full">
      <div className="flex justify-between mb-5">
        <div className="flex items-center">
          <div className="text-3xl font-bold text-gray-900">Gestion des plafonds du dossier {client.label}</div>
        </div>
      </div>
      <Help />
      <div className="flex justify-between m-5 items-center">
        <div className="flex items-center">
          <div className="m-5">Définir (ou modifier) le plafond d'un utilisateur</div>
          <Select
            allowClear
            showSearch
            placeholder={"Choisir un utilisateur"}
            onChange={setUserEmail}
            value={userEmail}
            style={{ minWidth: 100 }}
          >
            {users.map(item => (
              <Select.Option key={item._id} value={item.email}>
                {item.email}
              </Select.Option>
            ))}
          </Select>
          {userEmail && (
            <div
              className="cursor-pointer m-5 px-6 py-2 leading-5 rounded-full bg-gray-800 text-white text-center"
              onClick={() => setIsUserFormOpen(true)}
            >
              Définir les plafonds
            </div>
          )}
        </div>
        <div
          className="cursor-pointer px-6 py-2 leading-5 rounded-full bg-gray-800 text-white text-center"
          onClick={() => setIsClientFormOpen(true)}
        >
          Modifier les plafonds au niveau du dossier {client.label}
        </div>
      </div>
      <ModalComponent
        title={`Modification plafonds l'utilisateur`}
        width={500}
        showModal={isUserFormOpen}
        closeModal={() => setIsUserFormOpen(false)}
      >
        <UserLimitForm
          key={selectedUserId}
          getLimitsBonusesList={getLimitsBonusesList}
          user_id={selectedUserId}
          closeModal={() => setIsUserFormOpen(false)}
          limitsBonus={selectedLimitsBonus}
        />
      </ModalComponent>
      <ModalComponent
        title={`Modification plafonds du dossier`}
        width={500}
        showModal={isClientFormOpen}
        closeModal={() => setIsClientFormOpen(false)}
      >
        <ClientLimitForm getLimitsBonusesList={getLimitsBonusesList} closeModal={() => setIsClientFormOpen(false)} />
      </ModalComponent>
      <Table rowKey="_id" columns={columns} dataSource={limitsBonusesList} pagination={false} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    client: currentClientSelector(state),
    limitsBonusesList: state.premium.bonusesLimitsList,
    token: state.auth.token
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getLimitsBonusesList: () => dispatch(fetchLimitsBonusesList())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Limits);



// WEBPACK FOOTER //
// src/containers/admin/premium/LimitsBonuses.js